<script>

let caracteristicaLinks={ id:Math.random(), itemLink:'en-curta.me/teste2'}
let links = [];
let linksObj = [];
let passagemModal=null;
let passagemModalEdicao=null;
let acesso=0;
export let loginPainel = ""
export let tipoUsuario;
export let nomeCliente="";
let abrirModalLogout=false;
//$:tipoUsuario = (sessionStorage.getItem("tipoUsuario") || tipoUsuario).toUpperCase();


import Celula from "./celulamicrosite.svelte";
import CaixaDialogo from "./modal_pergunta.svelte";
import PayPal from "./comprapaypal.svelte";
import {createEventDispatcher } from 'svelte';
import {onMount} from "svelte";
import {Button,  
  ButtonGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader} from "sveltestrap";
const dispatch = createEventDispatcher();
onMount(()=>{
BuscarLista();

});
function BuscarLista(){
 linksObj = [];
     console.log('aqui');
     
  var data = new FormData();
  data.append("login", loginPainel);
  
	fetch('http://microsites.en-curta.me/svelte/consulta.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
//  console.log(text);
  links =text.split("|");
 // console.log(links);
  
  for (let i in links){
      //console.log(links[i]);
        let obj = JSON.parse(links[i]);
        //console.log(obj.link_resultado);
        linksObj=[...linksObj, obj]
  
  }
  
  }
  ); 
  
})
.catch((error) => {
  console.error('Error:', error);
 
});
} 
function ConfirmarLogout(){
         passagemModal={
         abrirModal:true,
         titulo:"Logout",
         mensagem:"Deseja efetuar logout",
         botaoNegativo:"Cancelar",
         botaoPositivo:"Confirmar"

     }
     console.log(passagemModal);
}
function Logout(){
     passagemModal=null;
     dispatch("Logout");
     
}

function ChamarPlanos(){
    console.log("chamarplanos1");
    dispatch("ChamarPlano");
}
function ChamarTela(e){
    console.log(e.detail)
    dispatch("ChamarTela",e.detail)
}
</script>







<section>

<body class='back'>

{#if passagemModal!=null}
<CaixaDialogo passagemModal={passagemModal}
 on:CliqueNegativo={()=>passagemModal=null}
 on:CliquePositivo={Logout}

 />
{/if}

<div class=" container ">
	<div class="d-flex justify-content-center h-100 ">
		<div class="card ">
			<div class="card-header flex-nowrap">
				<h3 class="float-left">Painel de: {nomeCliente} {loginPainel}</h3> 
        
        
            <Button on:click={ConfirmarLogout} class="float-right" >Logout</Button>
				<p></p>
			</div>
			<div class="card-body">
				<div class="conteiner">
                        <div class="row">
                    

                                <div class="col-12 scrool">
                                  
                                        <h6>Seus microssites<i class="ml-2"> plano:{tipoUsuario}</i> </h6>
                                        {#if tipoUsuario.toUpperCase()=="MASTER"}
                                        <br>
                                         <h6 class="mt-6"> <a  href="http://www.linkagenda.com.br/cartoesvisita/index.php?tipo=microsite&escola=andlline">Solicitar assistência</a>  </h6>
                                        {/if}
                                        <hr>
                                        {#if linksObj.length>0}
                                            {#each linksObj as lik}
                                                    <Celula  link={lik.link_resultado} id_unico={lik.id_unico} id={lik.id} acesso={lik.qtd} on:RefreshLista={BuscarLista} on:ChamarTela={ChamarTela}/>
                                            {/each}
                                        {:else}
                                        
                                        <h6 class="m-9">Você ainda não criou nenhum microssite</h6>
                                        {/if}

                            


                                
                                
                                
                                
                                </div>
                                
                        
                        </div>
               
                </div>


                 
                    
					
					
				
			</div>
			
			<div class="card-footer">
				<div class="d-flex justify-content-center links">
					 
                                 
                    <Button on:click={ChamarPlanos}>Criar novos microssites</Button> 
                                 
				</div>
				
			</div>
		</div>
	</div>
</div>


</body>

</section>



<style>


@import url('https://fonts.googleapis.com/css?family=Numans');
body{
    
    background-color: black}
.back{
background-image: url('../img/back.jpg'); 
background-size: cover;
background-repeat: no-repeat;

height: 100%;
padding: 10px;
font-family: 'Numans', sans-serif;

}

.container{
height: 100%;
align-content: center;
}

.card{
height: 580px;
margin-top:100px;
margin-bottom: 30px;
width: 95%;
background-color: rgba(255,255,255,1) !important;

}

.social_icon span{
font-size: 60px;
margin-left: 10px;
color: #FFC312;
}

.social_icon span:hover{
color: white;
cursor: pointer;
}

.card-header h3{
color: black;
}

.social_icon{
position: absolute;
right: 20px;
top: -45px;
}

.input-group-prepend span{
width: 50px;
background-color: #FFC312;
color: black;
border:0 !important;
}

input:focus{
outline: 0 0 0 0  !important;
box-shadow: 0 0 0 0 !important;

}

.remember{
color: white;
}

.remember input
{
width: 20px;
height: 20px;
margin-left: 15px;
margin-right: 5px;
}

.login_btn{
color: black;
background-color: #FFC312;
width: 100px;
}

.login_btn:hover{
color: black;
background-color: white;
}

.links{
color: white;
}
.links a{
margin-left: 4px;
}
.tabular{
	margin-left:  20px;
}

.borda-esquerda{
    height: 500px;
    border-style: solid;
    border-color: gray;
    border-width: 0px 0.5px 0px 0px;
    
}
.scrool{
    height: 400px;
    overflow:auto;
    padding-right: 50px
}

</style>